import React, { useState, useEffect } from "react";
import { Modal, Button, Form, TimePicker, Row, Col, Input } from "antd";
import { ModalXIcon, OraBukur } from "../../../../assets/icons/index";
import {
  getDisabledAfterCustomHours,
  getDisabledBeforeCustomHours,
  getDisabledBeforeCustomMinutes,
  getDisabledAfterCustomMinutes,
} from "../../../dashboard/utils/disabledTimeFilters";
import { RichTextEditor } from "../../../commonComponents";
import dayjsTZ from "../../../../utils/dayjs";
import MondayButton from "../../../commonComponents/MondayButton/MondayButton";
import { useSelector } from "react-redux";
import { Checkbox } from "../../../commonComponents";

function CreateShiftModal({
  setVisible,
  visible,
  onChange,
  addItems,
  form,
  data,
  setTableData,
  setUpdateData,
  updateItems,
  updateData,
  onNestedChange,
}) {
  const { isDarkMode } = useSelector((state) => state.usersList);
  // const { TextArea } = Input;
  const format = "HH:mm";
  const [isPaid, setIsPaid] = useState(null);
  // console.log(updateData);
  //   const [form] = Form.useForm();
  //fill up the form if the modal is opend for update
  useEffect(() => {
    // console.log({ updateData });
    if (!!Object.keys(updateData || {}).length) {
      form.setFieldsValue({
        // shiftId: updateData?.shiftId,
        shiftName: updateData?.shiftName,
        shiftDescription: updateData?.shiftDescription,
        shiftStartTime: updateData?.shiftStartTime
          ? dayjsTZ(updateData?.shiftStartTime)
          : null,
        shiftEndTime: updateData?.shiftEndTime
          ? dayjsTZ(updateData?.shiftEndTime)
          : null,
        breakStartTime: updateData?.shiftBreak?.breakStartTime
          ? dayjsTZ(updateData?.shiftBreak?.breakStartTime)
          : null,
        breakEndTime: updateData?.shiftBreak?.breakEndTime
          ? dayjsTZ(updateData?.shiftBreak?.breakEndTime)
          : null,
        isBreakTimePaid: updateData?.shiftBreak?.isBreakTimePaid,
        // createdAt: moment(),
      });
    }
    setIsPaid(!!updateData?.shiftBreak?.isBreakTimePaid);
  }, [updateData]);

  const handleIsPaidChange = (e) => {
    setIsPaid(e.target.checked);
    // console.log(e.target.checked);
    onNestedChange("shiftBreak", "isBreakTimePaid", e.target.checked);
  };

  const onClose = () => {
    // console.log("sjkfksdjfhskdjfh");
    setIsPaid(false);
    setUpdateData(null);
    setVisible(false);
    form.resetFields();
  };

  //region RETURN
  return (
    <div>
      <Modal
        title="Krijo një orar të ri"
        centered
        destroyOnHidden={true}
        className={`paisjet-orarit-modal ${
          isDarkMode ? "dark darkHeader" : "lightHeader"
        }`}
        wrapClassName="paisjet-orarit"
        open={visible}
        closeIcon={<ModalXIcon />}
        keyboard={false}
        onCancel={() => {
          onClose();
        }}
        width={900}
        maskClosable={false}
        footer={[
          <MondayButton
            className="mondayButtonRed"
            key="close"
            onClick={() => {
              onClose();
            }}
          >
            Mbyll
          </MondayButton>,
          <MondayButton
            className="mondayButtonGreen"
            onClick={() => {
              const formVal = form.getFieldsValue();
              if (updateData) {
                updateItems(formVal);
              } else {
                addItems(formVal);
              }
            }}
          >
            Ruaj Ndryshimet
          </MondayButton>,
        ]}
      >
        <Form form={form}>
          <div className="paisje-orarit-content">
            <div className="logo-container">
              <OraBukur />
            </div>
            <div className="grid-container">
              <Row style={{ width: "100%", marginBottom: 30 }}>
                <Col span={12}>
                  <h3>Titulli i Orarit:</h3>
                  <Form.Item
                    name="shiftName"
                    rules={[
                      {
                        required: true,
                        message: "Ju lutem shkruani titullin e orarit !",
                      },
                    ]}
                  >
                    <Input placeholder="Shkruaj titullin " />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <h3>Përshkrimi i orarit:</h3>
                  <Form.Item
                    name="shiftDescription"
                    rules={[
                      {
                        required: true,
                        message: "Ju lutem shkruani përshkrimin e orarit !",
                      },
                    ]}
                  >
                    <RichTextEditor />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ width: "100%" }}>
                <Col span={12}>
                  <h3>Orari i fillimit:</h3>
                  <Form.Item
                    name="shiftStartTime"
                    rules={[
                      {
                        required: true,
                        message: "Ju lutem selekto orën e fillimit !",
                      },
                    ]}
                  >
                    <TimePicker
                      className="konfigurimet-shift-picker"
                      placeholder="Selekto orën e fillimit"
                      format={format}
                      onChange={(val) => onChange("shiftStartTime", val)}
                      // disabledTime={() => ({
                      //   disabledHours: () =>
                      //     getDisabledAfterCustomHours(
                      //       !!updateData
                      //         ? updateData.shiftEndTime
                      //         : data.shiftEndTime
                      //     ),
                      //   disabledMinutes: (hour) =>
                      //     getDisabledAfterCustomMinutes(
                      //       !!updateData
                      //         ? updateData.shiftEndTime
                      //         : data.shiftEndTime,
                      //       hour
                      //     ),
                      // })}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <h3>Orari i mbarimit:</h3>
                  <Form.Item
                    name="shiftEndTime"
                    rules={[
                      {
                        required: true,
                        message: "Ju lutem selekto orën e mbarimit !",
                      },
                    ]}
                  >
                    <TimePicker
                      className="konfigurimet-shift-picker"
                      placeholder="Selekto orën e mbarimit"
                      format={format}
                      onChange={(val) => onChange("shiftEndTime", val)}
                      disabledTime={() => ({
                        disabledHours: () =>
                          getDisabledBeforeCustomHours(
                            !!updateData
                              ? updateData.shiftStartTime
                              : data.shiftStartTime
                          ),
                        disabledMinutes: (hour) =>
                          getDisabledBeforeCustomMinutes(
                            !!updateData
                              ? updateData.shiftStartTime
                              : data.shiftStartTime,
                            hour
                          ),
                      })}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ width: "100%" }}>
                <Col span={12}>
                  <h3>Fillimi i pushimit:</h3>
                  <Form.Item
                    name="breakStartTime"
                    rules={[
                      {
                        required: true,
                        message: "Ju lutem selekto fillimin e pushimit !",
                      },
                    ]}
                  >
                    <TimePicker
                      className="konfigurimet-shift-picker"
                      placeholder="Selekto orën e fillimit"
                      format={format}
                      onChange={(val) =>
                        onNestedChange("shiftBreak", "breakStartTime", val)
                      }
                      disabledTime={() => ({
                        disabledHours: () =>
                          getDisabledBeforeCustomHours(
                            !!updateData
                              ? updateData.shiftStartTime
                              : data.shiftStartTime
                          ),
                        disabledMinutes: (hour) =>
                          getDisabledBeforeCustomMinutes(
                            !!updateData
                              ? updateData.shiftStartTime
                              : data.shiftStartTime,
                            hour
                          ),
                      })}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <h3>Mbarimi i pushimit:</h3>
                  <Form.Item
                    name="breakEndTime"
                    rules={[
                      {
                        required: true,
                        message: "Ju lutem selekto orën e mbarimit !",
                      },
                    ]}
                  >
                    <TimePicker
                      className="konfigurimet-shift-picker"
                      placeholder="Selekto orën e mbarimit"
                      format={format}
                      onChange={(val) =>
                        onNestedChange("shiftBreak", "breakEndTime", val)
                      }
                      disabledTime={() => ({
                        disabledHours: () =>
                          getDisabledAfterCustomHours(
                            !!updateData
                              ? updateData.shiftEndTime
                              : data.shiftEndTime
                          ),
                        disabledMinutes: (hour) =>
                          getDisabledAfterCustomMinutes(
                            !!updateData
                              ? updateData.shiftEndTime
                              : data.shiftEndTime,
                            hour
                          ),
                      })}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ width: "100%" }}>
                <Col span={12}>
                  <Form.Item label="Pushim i paguar:" name="isBreakTimePaid">
                    <Checkbox
                      fill={"grey"}
                      onChange={handleIsPaidChange}
                      checked={isPaid}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </div>
        </Form>
      </Modal>
    </div>
  );
}
export default CreateShiftModal;
